import React, { FC } from 'react';

import { WELCOME_BUTTON, REQUEST_BUTTON } from 'common/config/app.config';

import { Button } from 'common/components';

import './NavigationSection.scss';
import { ButtonSize } from 'common/enums';

type NavigationSectionProps = {
    hasAccess: boolean;
    onNavigation: () => void;
};
const NavigationSection: FC<NavigationSectionProps> = ({ hasAccess, onNavigation }) => {
    return (
        <div className="navigation-container">
            <Button className="navigation-button" onClick={onNavigation} size={ButtonSize.Medium}>
                {hasAccess === true ? WELCOME_BUTTON : REQUEST_BUTTON}
            </Button>
        </div>
    );
};

export default NavigationSection;
